export default __webpack_public_path__ + "static/media/proj4.f70ef98e.png";